/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanEditRequestDto { 
    id: number;
    loanOfficerUserId?: number | null;
    economicSectorId?: number | null;
    subEconomicSectorId?: number | null;
    openingBalance?: number | null;
    economicSubSectorBussinessName?: string | null;
}

